import React, { useEffect } from 'react';

import { SketchPicker } from "react-color";
import { OverlayTrigger, Popover } from "react-bootstrap";

import {get} from 'lodash';
import styles from './banner.module.scss';
import { FILTERS } from 'src/constants/banner';
import { BannerView } from 'src/components/banner';
import { CollectionSettings, DealRoomSettings } from 'src/types/settings/accountManagement';

interface BannerFiltersProps {
  collection: CollectionSettings | DealRoomSettings;
  onChange: (field: string, value: any) => void;
  onFilterClick?: (field: string, value: any) => void;
}

const BannerFilters: React.FC<BannerFiltersProps> = ({ collection, onChange, onFilterClick }) => {

  const banner = collection.banner;
  const [originalBanner, setOriginalBanner] = React.useState({
    filter: banner?.filter,
    overlayColor: banner?.overlayColor,
  });

  useEffect(() => {
    setOriginalBanner({
      filter: banner?.filter,
      overlayColor: banner?.overlayColor,
    });
  }, []);

  const updateFilters = (value: any) => {
    onChange('banner', {
      ...collection.banner,
      ...value, 
    });
  };

  const handleClick = (value: any) => {
    updateFilters(value);
    setOriginalBanner(value);
    onFilterClick?.('banner',{
      ...collection.banner,
      ...value, 
    }); // notify filter click
  }
  
  const handleMouseOver = (value: any) => { 
    updateFilters(value);
  }

  const handleMouseOut = () => {
    updateFilters({
      filter: originalBanner?.filter,
      overlayColor: originalBanner?.overlayColor,
    });
  }

  const getColor = (value: any) => {
    const r = get(value, 'r', 0);
    const g = get(value, 'g', 0);
    const b = get(value, 'b', 0);
    const a = get(value, 'a', 1);
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  };

  if(!banner) {
    return null;
  }

  return (
    <div className={styles.bannerFilters}>
      <div className={styles.filterHeader}>
        <h2 className={styles.filterTitle}>
          Choose the filter you want to apply
        </h2>

        {originalBanner?.overlayColor && originalBanner?.filter === banner?.filter && (
          <div className={styles.dropdownWrapper}>
            <OverlayTrigger
              trigger="click"
              placement="bottom"
              rootClose
              overlay={
                <Popover id="popover-color-picker" className={styles.sketchPickerPopover}>
                  <Popover.Body>
                    <SketchPicker
                      color={banner.overlayColor}
                      onChangeComplete={(color) => {
                        const updatedOverlayColor = color.rgb;
                        updateFilters({ overlayColor: updatedOverlayColor });
                        setOriginalBanner((prev) => ({
                          ...prev,
                          overlayColor: updatedOverlayColor,
                        }));
                      }}
                    />
                  </Popover.Body>
                </Popover>
              }
            >
              <div className={styles.colorTrigger}>
              <button
                style={{
                  backgroundColor: getColor(banner.overlayColor),
                }}
                className={styles.changeColorButton}
              />
              <span className={styles.changeColorText}>change color</span>
              </div>
            </OverlayTrigger>
          </div>
        )}
      </div>
      
      <div className={styles.filters}>
        {FILTERS.map((filter) => {

          const bannerItem = {
            ...banner!,
            ...filter.value,
            filter: filter.value.filter ?? undefined,
          } as unknown as any;

          return (
            <div key={filter.label} className={styles.filter} 
              onClick={() => {
                handleClick(filter.value);
              }}
              onMouseOver={() => handleMouseOver(filter.value)}
              onMouseOut={handleMouseOut}
            >
              <BannerView banner={bannerItem} height={200} />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export { BannerFilters };